import DashboardItem from './DashboardItem'

export default DashboardItem
